import { render, staticRenderFns } from "./AttributeDialog.vue?vue&type=template&id=1cc6e476"
import script from "./AttributeDialog.vue?vue&type=script&lang=js"
export * from "./AttributeDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports